import { useState } from 'react'
import { css, Theme } from '@emotion/react'
import { Box, Typography, Collapse } from '@mui/material'

import { returnFeed } from '~/utils/returnFeed'

const createData = (
  state: boolean,
  setter,
  question: string,
  answer: string
) => {
  return { state, setter, question, answer }
}

const FAQListWebCreative = () => {
  const [openOne, setOpenOne] = useState(false)
  const [openTwo, setOpenTwo] = useState(false)
  const [openThree, setOpenThree] = useState(false)
  const [openFour, setOpenFour] = useState(false)

  const rows = [
    createData(
      openOne,
      setOpenOne,
      'LPを制作する際のリスクを教えてください。',
      `LP制作において、ウェブ広告とミスマッチを引き起こしているLPは効果が薄いとされています。
      eduadでは、ウェブ広告とLP制作をワンストップサービスで行うため、リスクを避けることができます。`
    ),
    createData(
      openTwo,
      setOpenTwo,
      'LP制作／動画制作だけの依頼でも大丈夫ですか？',
      'もちろん問題ありません。現在貴社内で取り組んでいるマーケティング戦略をお伺いした上で、その効果を最大限引き出すことのできるLP/クリエイティブを制作してまいります。'
    ),
    createData(
      openThree,
      setOpenThree,
      'LP制作／動画制作にどのくらいの時間がかかりますか？',
      'LP制作ですと3週間〜1ヶ月程度、動画制作では長さにもよりますが、2~4週間程度で制作可能です。お急ぎの場合はご相談いただければと思います。'
    ),
    createData(
      openFour,
      setOpenFour,
      'LP制作／動画制作の費用はどれくらいですか？',
      'LP制作は1本10万円〜、動画制作は2万円〜受注可能です。詳しくは、料金・プランのページをご確認ください。'
    ),
  ]

  return (
    <>
      <Box css={styles.faq_container}>
        <Box css={styles.title_container}>
          <Typography color='primary' variant='h2' css={styles.section_title}>
            ウェブクリエイティブ・ウェブサイト制作・動画制作について
          </Typography>
        </Box>
        <ul css={styles.list}>
          {rows.map(row => (
            <li
              key={row.question}
              css={styles.item}
              className={row.state ? 'isActive' : null}>
              <div
                css={styles.accordion_head}
                onClick={() => row.setter(!row.state)}>
                {row.question}
              </div>
              <div>
                <Collapse
                  in={row.state}
                  timeout={{
                    enter: 300,
                    exit: 500,
                  }}
                  unmountOnExit>
                  <div css={styles.accordion_body}>
                    <p>{returnFeed(row.answer)}</p>
                  </div>
                </Collapse>
              </div>
            </li>
          ))}
        </ul>
      </Box>
    </>
  )
}

const styles = {
  faq_container: css`
    margin-left: 0;
    padding: 20px;
  `,
  title_container: css`
    width: 100%;
    padding: 20px 0%;
    border-bottom: 1px solid #dfdddd;
    @media (min-width: 960px) {
      padding: 50px 0;
    }
  `,
  section_title: css`
    font-family: 'Noto sans JP', sans-serif;
    font-weight: 700;
    font-size: 1.5rem;
    text-align: right;
    &:before {
      content: '-';
      margin-right: 1rem;
    }
  `,
  list: css`
    list-style: none;
    padding-inline-start: 0;
    @media (min-width: 960px) {
      margin-left: 50px;
    }
  `,
  item: css`
    cursor: pointer;
    padding-left: 10px;
    border-bottom: 0.2px solid #dfdddd;
  `,
  accordion_head: (theme: Theme) => css`
    position: relative;
    font-family: 'Noto sans JP', sans-serif;
    font-weight: 500;
    font-size: 0.9rem;
    color: ${theme.palette.primary.main};
    padding: 30px 40px 30px 0;
    &:after {
      content: '\\f078';
      font-family: 'Font Awesome 5 Free';
      font-weight: 900;
      position: absolute;
      right: 10px;
      transition: all 0.3s ease-in-out;
    }
    .isActive &:after {
      transform: rotate(180deg);
    }
    @media (min-width: 960px) {
      font-size: 1.2rem;
    }
  `,
  accordion_body: (theme: Theme) => css`
    padding: 20px;
    color: ${theme.palette.primary.main};
  `,
}

export default FAQListWebCreative
